







































































































import { Vue, Component } from 'vue-property-decorator';
import axios from 'axios';
@Component({
    name: 'doors'
})

export default class Doors extends Vue
{
    actualProgress: number = 1;
    actualPath: number = 1;
    clickSong = this.$store.state.global.clickSong;
    gameFinished: boolean = false;
    characters = this.$store.state.global.characters
    nurseAvaible = false;
    secondNurseAvaible = false;
    rules = false;
    maxScores = {
        'one': 16,
        'two': 15,
        'three': 16
    }

    mounted()
    {
        this.$store.commit('disableEffect');

        axios
            .get('game/points/characters')
            .then(response =>
            {
                this.$store.commit('setCharacters', response.data);
            })
            .catch(error => console.log(error));
    }

    checkNurse()
    {
        if(this.actualProgress === 1)
        {
            setTimeout(() =>
            {
                this.nurseAvaible = true;
            },500);

            setTimeout(() =>
            {
                this.nurseAvaible = false;
            },9000);

            setTimeout(() =>
            {
                this.nurseAvaible = true;
                this.secondNurseAvaible = true;
            },9500);

            setTimeout(() =>
            {
                this.secondNurseAvaible = false;
                this.nurseAvaible = false;
            },15500);
        }
    }
    toggleTutorial()
    {
        this.$store.commit('toggleTutorial');
    }

    get volume()
    {
        return this.$store.state.global.soundValue;
    }
    set volume(value)
    {
        this.$store.commit('setVolume', value/100);
    }

    changeVolume(event: any)
    {
        this.$store.commit('setVolume', event.target.value/100);
    }
    toggleSound()
    {
        this.$store.commit('toggleSound');
    }

    handleClick()
    {
        this.clickSong.play();
    }

    refresh()
    {
        this.toggleTutorial();
        this.$store.commit('resetScore');
        axios.post('game/state/reset',
            {

            })
            .catch(error => console.log(error));
        this.redirect({ name: 'dashboard' });
    }

    created()
    {
        axios
            .get('game/state',
                {

                })
            .then(response =>
            {
                this.actualProgress = response.data.level;
                this.actualPath = response.data.path;
                this.checkNurse();
                if(response.status == 204)
                {
                    this.gameFinished = true;
                }
            })
            .catch(error => console.log(error));
    }

    totalScore(character: any)
    {
        let total = 0;
        for (const round in character)
        {
            total += character[round];
        }
        return total;
    }
}
